import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import React from 'react'
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import SearchStringOrIntReq from '../../../../Classes/Models/Requests/SearchStringOrIntReq';
import Moment from 'react-moment';
import ConfirmedAppointmentBox from '../../AppointmentDays/AppointmentDayDetails/ConfirmedAppointmentBox';
import { Icon } from '@mui/material';
import AddmissionButton from 'layouts/AccountingSessions/AddmissionButton';
import AppointmentsApi from '../../../../Classes/API/Appointments/AppointmentsApi';
const AppHourCellSimple = ({ AppHour, setSelectedAppHour }) => {
  const navigate = useNavigate();
  const GoToAccSessionDetails = (AccSession) => {
    navigate(
      '/AccountingSessions/Details',
      {
        state: {
          SearchSession: AccSession,
        }
      }
    )
  }

  // make function that will calculate the time difference between the appointment hour and the current time

  const GetAppHourCell = (AppHour) => {
    return (

        <MDBox>
          {GetButtons(AppHour).map((Button, index) => {
            return (
              <MDBox className="d-flex justify-content-between" sx={{ borderBottom: '1px solid #ccc', marginBottom: '0.3em', paddingBottom: '0.2em' }} >
                {Button}
              </MDBox>
            )
          })}
          {/* AddButtonsHere */}
          <MDBox className="d-flex justify-content-between">
            {
              setSelectedAppHour &&
              <button className="btn btn-sm btn-primary" onClick={() => {
                setSelectedAppHour(AppHour)
              }}>
                <Icon>add</Icon>
              </button>
            }
            {/* Small font dark badge span for Id: {AppHour.id} */}

            {/* <button className="btn btn-sm btn-danger">
              <Icon>delete</Icon>
            </button> */}
          </MDBox>
        </MDBox>

    )
  }

  const DeleteAppointment = async (_accSess) => {
    let DeleteAppointmentReq = new SearchStringOrIntReq();
    DeleteAppointmentReq.SearchInt = _accSess.id;
    let confirmation = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    });
    if (!confirmation.value) {
      return;
    }
    Swal.fire({
      title: 'Deleting...',
      text: 'Please wait...',
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
    let result = await AppointmentsApi.ClearAccountingSessionAppointmentHour(DeleteAppointmentReq);
    if (result.status == "Success") {
      Swal.fire(
        'Deleted!',
        'Your file has been deleted.',
        'success'
      ).then(() => {
        window.location.reload();
      });
    }
    else {
      Swal.fire({
        title: 'Error',
        text: result.message,
        icon: 'error',
        confirmButtonText: 'Ok'
      })
    }
  }
  const GetButtons = (AppHour) => {
    let Buttons = []
    if (AppHour.getListedAccountingSessions.length > 0) {
      AppHour.getListedAccountingSessions.forEach(AccSession => {
        Buttons.push(
          <MDBox className="text-center" sx={{ display: "flex", flexDirection: "column"}}>
            <span style={{ margin: "1em" }} onClick={() => {
              GoToAccSessionDetails(AccSession)
            }} class="badge badge-success">
              {AccSession.sessionName} (Id: {AccSession.id}) | {AccSession.patientName} | {
                AccSession.getSessionFacilities.map((Sessionfacility) => {
                  return <span>
                    {Sessionfacility.getFacility.name}
                  </span>
                })
              }
            </span>
            <AddmissionButton AccSession={AccSession} />
            {/* <button className="btn btn-sm btn-dark ml-4" onClick={() => { DeleteAppointment(AccSession) }}>
              <Icon>delete</Icon>
            </button> */}
          </MDBox>
        )
      });
    }
    return Buttons

  }


  return (
    GetAppHourCell(AppHour)
  );
}

export default AppHourCellSimple